export default __webpack_public_path__ + "static/background_smoke-be62c423addb0d6b3e93cc72e348a8de.png";